import { PLAYBACK_SCOPE } from "components/scrapEyeDataDashboard/VideoPlayer/constants";

// Hotkey scope names of the labelling surfaces and their dialogs, and the lists dialogs
// disable. The playback scope belongs to the video player and is defined beside it.
export const MANUAL_REVIEW_SCOPE = "manualReview";
export const EVENT_LABELLING_SCOPE = "eventLabelling";
export const EVENT_LABELLING_DELETE_SCOPE = "eventLabellingDelete";
export const EDIT_EVENT_SCOPE = "editEvent";
export const COMMENT_REVIEW_EDIT_SCOPE = "commentReviewEdit";
export const LABELLING_GUIDE_SCOPE = "labellingGuide";
export const NAVIGATION_SCOPE = "navigation";
export const CAMERA_SELECTION_SCOPE = "cameraSelection";

// Never toggled by area mode. A dialog that disables it makes the
// labelling keydown handler and area-mode arming inert without affecting the scopes
// area mode itself toggles.
export const LABELLING_KEYBOARD_SCOPE = "labellingKeyboard";

const VIDEO_PLAYER_SCOPES = [
  PLAYBACK_SCOPE,
  NAVIGATION_SCOPE,
  CAMERA_SELECTION_SCOPE,
] as const;

export const AREA_MODAL_DISABLED_SCOPES = [
  EVENT_LABELLING_SCOPE,
  EVENT_LABELLING_DELETE_SCOPE,
  ...VIDEO_PLAYER_SCOPES,
] as const;

export const IDENTIFY_EVENTS_HOTKEY_SCOPES = [
  PLAYBACK_SCOPE,
  EVENT_LABELLING_SCOPE,
  EVENT_LABELLING_DELETE_SCOPE,
  LABELLING_KEYBOARD_SCOPE,
] as const;

export const LABELLING_HOTKEY_SCOPES = [
  MANUAL_REVIEW_SCOPE,
  ...AREA_MODAL_DISABLED_SCOPES,
  LABELLING_KEYBOARD_SCOPE,
] as const;

export const EDIT_EVENT_SUB_MODAL_DISABLED_SCOPES = [
  EDIT_EVENT_SCOPE,
  COMMENT_REVIEW_EDIT_SCOPE,
] as const;

// Suppressed while an area-selection or area-material-mapping sub-modal is open, on the
// manual-review page or inside the bring-in modal's own labelling surface. Must be a
// stable reference — the suppression effect re-runs when its identity changes.
export const SUB_MODAL_HOTKEY_SCOPES = [
  MANUAL_REVIEW_SCOPE,
  EVENT_LABELLING_DELETE_SCOPE,
  ...VIDEO_PLAYER_SCOPES,
] as const;
